module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"remove":"Entfernen","attention":"Achtung!","content will be removed":"Alle Inhalte dieser Box werden gelöscht. Fortfahren?"}}')
  delete Component.options._Ctor
}
